import { Controller } from "@hotwired/stimulus"

// Debounced live preview. POSTs the textarea content to a server endpoint
// (Panel::PreviewsController) that renders Markdown -> HTML and returns plain
// text/html, which we set as innerHTML on the preview pane.
export default class extends Controller {
  static targets = ["source", "preview", "stats"]
  static values = {
    url: String,
    debounce: { type: Number, default: 250 }
  }

  connect() {
    this.refresh()
    this.updateStats()
  }

  disconnect() {
    clearTimeout(this._t)
    if (this._ac) this._ac.abort()
  }

  queue() {
    this.updateStats()
    clearTimeout(this._t)
    this._t = setTimeout(() => this.refresh(), this.debounceValue)
  }

  async refresh() {
    if (!this.hasSourceTarget || !this.hasPreviewTarget) return
    if (this._ac) this._ac.abort()
    this._ac = new AbortController()

    const fd = new FormData()
    fd.append("content", this.sourceTarget.value)

    try {
      const res = await fetch(this.urlValue, {
        method: "POST",
        body: fd,
        headers: this.csrfHeaders(),
        signal: this._ac.signal
      })
      if (!res.ok) return
      const html = await res.text()
      this.previewTarget.innerHTML = html
    } catch (err) {
      if (err.name !== "AbortError") console.error(err)
    }
  }

  updateStats() {
    if (!this.hasStatsTarget || !this.hasSourceTarget) return
    const text = this.sourceTarget.value
    const lines = text === "" ? 0 : text.split("\n").length
    const chars = text.length
    const words = text.trim().split(/\s+/).filter(Boolean).length
    const minutes = Math.max(1, Math.ceil(words / 200))
    this.statsTarget.textContent =
      `markdown · ${lines} linhas · ${this.short(chars)} chars · ${minutes} min leitura`
  }

  short(n) {
    if (n < 1000) return `${n}`
    return `${(n / 1000).toFixed(1)}k`
  }

  csrfHeaders() {
    const meta = document.querySelector('meta[name="csrf-token"]')
    return meta ? { "X-CSRF-Token": meta.content } : {}
  }
}
